import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface User {
    id: number;
    full_name: string | null;
    email: string | null;
    email_verified: boolean;
    github_login: string | null;
    github_email: string | null;
    avatar_url: string | null;
    plan: 'free' | 'pro' | 'enterprise';
    installation_id: number | null;
}

interface AuthState {
    user: User | null;
    accessToken: string | null;
    isAuthenticated: boolean;
    isLoading: boolean;
}

const initialState: AuthState = {
    user: null,
    accessToken: null,
    isAuthenticated: false,
    isLoading: true,
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        authCheckComplete: (state) => {
            state.isLoading = false;
            state.isAuthenticated = false;
        },
        loginSuccess: (state, action: PayloadAction<{ user: User; accessToken: string }>) => {
            state.user = action.payload.user;
            state.accessToken = action.payload.accessToken;
            state.isAuthenticated = true;
            state.isLoading = false;
        },
        restoreSession: (state, action: PayloadAction<{ user: User; accessToken: string }>) => {
            state.user = action.payload.user;
            state.accessToken = action.payload.accessToken;
            state.isAuthenticated = true;
            state.isLoading = false;
        },
        updateUser: (state, action: PayloadAction<Partial<User>>) => {
            if (state.user) {
                state.user = { ...state.user, ...action.payload };
            }
        },
        logout: (state) => {
            state.user = null;
            state.accessToken = null;
            state.isAuthenticated = false;
            state.isLoading = false;
        },
    },
});

export const { authCheckComplete, loginSuccess, restoreSession, updateUser, logout } = authSlice.actions;
export default authSlice.reducer;
